module.exports = __webpack_public_path__ + "static/media/IMG_1269-1.1b25b6f2.jpg";